<template>
    <div>
        <div class="top-level-menu-status-list">
            <top-level-menu-status-item-view v-for="statusItem in statusItems"
                                             :statusItem="statusItem"
                                             :selectedItem="selectedItem"
                                             :expanded="customReasonsOpen ? 'true' : 'false'"
                                             :canExpand="canExpand(statusItem)"
                                             v-bind:key="statusItem.value"
                                             @clicked="itemClicked">

            </top-level-menu-status-item-view>
        </div>
        <div v-bind:class="customReasonsClass">
            <top-level-menu-custom-reason-item-view v-for="customReason in extendedCustomAwayReasons"
                                                    :customReason="customReason"
                                                    :key="customReason.id"
                                                    @clicked="itemClicked">
            </top-level-menu-custom-reason-item-view>
        </div>
    </div>
</template>

<script>
    import * as ApiResources from 'assets/data/apiResources.json';
    import * as LpAjaxTransport from 'lptransporter/lpajax';
    import * as CONST from 'const';
    import urlResolver from "urlResolver";

    import TopLevelMenuStatusItemView from './TopLevelMenuStatusItemView';
    import TopLevelMenuCustomReasonItemView from './TopLevelMenuCustomReasonItemView';
    import {
        Vuex,
        sessionManager,
        environmentGetterTypes,
        storeModuleTypes,
        environmentActionTypes,
        gChannel,
        AGENT_STATUS_DATA_STATES
    } from "vue-infra";
    import { leDialog } from 'lp-vue-components';

    const getters = Vuex.mapGetters(storeModuleTypes.ENVIRONMENT, [
        environmentGetterTypes.CURRENT_AGENT_STATUS,
        environmentGetterTypes.RESOLVE_CUSTOM_AWAY_REASONS,
        environmentGetterTypes.AGENT_STATUS_DATA_STATE
    ]);

    export default {
        name: "top-level-menu-status-list",
        data() {
            const online = this.$translator.translate(`LEWebAgent.${CONST.DEFAULT_AGENT_STATUSES.online.translatorParameter}`);
            const away = this.$translator.translate(`LEWebAgent.${CONST.DEFAULT_AGENT_STATUSES.away.translatorParameter}`);
            const backIn5 = this.$translator.translate(`LEWebAgent.${CONST.DEFAULT_AGENT_STATUSES.occupied.translatorParameter}`);

            return {
                customReasonsOpen: false,
                statusItems: [
                    Object.assign({}, CONST.DEFAULT_AGENT_STATUSES.away, {
                        title: away,
                        availabilityTitle: away,
                        customReasonsAvailable: false
                    }),
                    Object.assign({}, CONST.DEFAULT_AGENT_STATUSES.occupied, {
                        title: backIn5,
                        availabilityTitle: backIn5,
                    }),
                    Object.assign({}, CONST.DEFAULT_AGENT_STATUSES.online, {
                        title: online,
                        availabilityTitle: online,
                    })],
                selectedItem: {},
                extendedCustomAwayReasons: [],
                CONST,
            }
        },
        created() {
            gChannel.register('LiveEngageCommon', 'customAgentAwayReason:update', this.getAwayCustomReasons);
            this.setSelectedItem();
            this.getAwayCustomReasons();
        },
        computed: {
            currentStatus: getters[environmentGetterTypes.CURRENT_AGENT_STATUS],
            customAwayReasons: getters[environmentGetterTypes.RESOLVE_CUSTOM_AWAY_REASONS],
            agentStatusDataState: getters[environmentGetterTypes.AGENT_STATUS_DATA_STATE],
            customReasonsClass() {
                return {
                    'top-level-menu-custom-reasons-list theme-light': true,
                    'hide': !this.customReasonsOpen
                }
            }
        },
        methods: {
            toggleCustomReasons: function () {
                this.customReasonsOpen = !this.customReasonsOpen;
            },
            setSelectedItem() {
                let selectedItem = [];
                if(this.agentStatusDataState === AGENT_STATUS_DATA_STATES.STATUS_DISCREPANCY) {
                    this.selectedItem = {};
                } else if (this.currentStatus.reasonId && this.currentStatus.reasonId > 0) {
                    selectedItem = this.extendedCustomAwayReasons.filter((item) => item.id == this.currentStatus.reasonId);
                } else {
                    selectedItem = this.statusItems.filter((item) => item.value === this.currentStatus.value);
                }

                if (selectedItem.length > 0) {
                    this.selectedItem = selectedItem[0];
                    this.updateAwayStatus(this.selectedItem);
                }
            },
            itemClicked(item) {
                if (item.customReasonsAvailable) {
                    this.toggleCustomReasons();
                }
                else {
                    this.$store.dispatch(`${storeModuleTypes.ENVIRONMENT}/${environmentActionTypes.REQUEST_AGENT_STATUS_CHANGE}`, {
                        value: item.value,
                        reasonId: item.customReason ? item.id : undefined
                    });
                    this.$emit('clicked');
                    if (this.customReasonsOpen) {
                        this.toggleCustomReasons();
                    }
                }
            },
            extendCustomReasons() {
                const customAwayReasons = this.customAwayReasons.map(reason => {
                    const selectedItem = this.statusItems.filter((item) => item.value === reason.state);
                    if (selectedItem.length > 0) {
                        const extendWith = Object.assign({}, selectedItem[0]);
                        extendWith.customReasonsAvailable = false;
                        return Object.assign({ customReason: true }, reason, extendWith);
                    }
                    return reason;
                });

                let awayReason = this.statusItems.filter((item) => item.value === 'Away');
                awayReason[0].customReasonsAvailable = customAwayReasons.length > 0;
                this.extendedCustomAwayReasons = customAwayReasons;
            },
            getAwayCustomReasons() {
                const domain = sessionManager.getCsdsServiceURI('accountConfigReadWrite');
                let url = urlResolver.getUrl(ApiResources.AccountConfig.AgentReasons.url, {
                    accountConfigReadWrite: domain,
                    accountId: sessionManager.getAccountId()
                });

                this.$store.dispatch(`${storeModuleTypes.ENVIRONMENT}/${environmentActionTypes.UPDATE_CUSTOM_AWAY_REASONS}`, {
                    url: `${url}`,
                    data: {
                        v: 2.0,
                        include_deleted: false
                    },
                    success: this.extendCustomReasons,
                    transporter: LpAjaxTransport

                });
            },
            updateAwayStatus(selectedStatus) {
                let awayReason = this.statusItems.filter((item) => item.value === 'Away')[0];
                awayReason.availabilityTitle = selectedStatus.customReason ? selectedStatus.text : awayReason.title;
            },
            canExpand(item) {
              return item.value === CONST.DEFAULT_AGENT_STATUSES.away.value && !!item.customReasonsAvailable;
            },
        },
        watch: {
            currentStatus() {
                this.setSelectedItem();
            },
            customAwayReasons() {
                this.extendCustomReasons();

                //set again the selected item after we fetch the custom reasons
                this.setSelectedItem();
            }
        },
        components: {
            TopLevelMenuStatusItemView,
            TopLevelMenuCustomReasonItemView,
            leDialog,
        }
    }
</script>

<style scoped>

</style>
